import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8ed123e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-col-centered" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_2 = { class: "top-content" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "grid-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "grid-item-left",
  for: "market"
}, "Market", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "grid-item-left",
  for: "contractId"
}, "Contract ID", -1))
const _hoisted_8 = { class: "grid-item-left" }
const _hoisted_9 = {
  class: "date-picker",
  style: {"width":"100%"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "grid-item-left",
  for: "caseReference"
}, "Case Reference ID", -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "grid-item-left" }
const _hoisted_13 = { class: "grid-item-left" }
const _hoisted_14 = { class: "grid-item-left" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "grid-item-left" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "grid-item-left" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "grid-item-left",
  for: "comments"
}, "Comments", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-col-centered" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "submit-btn",
    type: "submit"
  }, " CONFIRM CHANGES ")
], -1))

import { computed, ref, watch } from "vue";
import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Popup from "./Popup.vue";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import ToolTipLabel from "@/components/ToolTipLabel.vue";
import CurrencyInput from "@/components/CurrencyInput.vue";
import { MarketCurrency } from "@/services/helpers/Helper";
import { insuranceClaims } from "@/services/network";
import IInsuranceForm from "@/Interfaces/InsuranceClaims/IInsuranceClaimsForm";
import {  MarketSelection } from '@/services/helpers/Helper';
import DateIgnoreTime from "@/types/DateIgnoreTime";
import { authService } from "@/auth/authSingleton";


export default /*#__PURE__*/_defineComponent({
  __name: 'InsuranceClaimsEditPopUp',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const markets = Object.entries(MarketSelection);
const FormatDatePicker = (date: Date) => {
    return date.toLocaleString("sv-SE").split(" ")[0].replaceAll("-", "/");
};
const textInputOptions = { format: "yyyy/MM/dd" };
const props = __props;
const selectedRow = computed({
    get() {
        return props.modelValue
    },
    set(val) {
        emits('update:modelValue', val);
    }
})
const emits = __emit;
const working = ref(false);
const selectedRowCopy = ref<Partial<IInsuranceForm>>({});

watch(selectedRow, (val)=>{
    if (val) {
        selectedRowCopy.value = Object.assign({}, val);
    }
});
function closeChild(){
    selectedRow.value = undefined;
}
const fullAmmountRequiredFields = ref(false)
function HandleFullAmountRequirementChange(event: Event): void{
    const target = event.target as HTMLInputElement;
    if(target.value != ""){
        fullAmmountRequiredFields.value = true
    }else{
        fullAmmountRequiredFields.value = false
    }
}
async function EditInsuranceClaim() {
    if(working.value) return;    
    const closeSpinner = useSpinnerPopup().show();
    try{
        if(JSON.stringify(selectedRowCopy.value)===JSON.stringify(selectedRow.value)){
            useNotifierWithErrFormatter().warn({msg: "No Change Applied"});
        }
        if(selectedRowCopy.value.paymentDate?.isValid()  && (selectedRowCopy.value.fullAmount == null || selectedRowCopy.value.fullAmount.toString() === "")){
            useNotifierWithErrFormatter().warn({msg: "When specifying 'Payment Date' remeber to specify 'Full Amount'"});
        }
        else{
            working.value=true
            let postRequest: IInsuranceForm = {
                market: selectedRowCopy.value?.market ?? 'GB',
                contractId: selectedRowCopy.value?.contractId || '',
                paymentDate: new DateIgnoreTime(selectedRowCopy.value?.paymentDate),
                caseReferenceId: selectedRowCopy.value?.caseReferenceId, 
                fullAmount: selectedRowCopy.value?.fullAmount, 
                excessAmount: selectedRowCopy.value?.excessAmount,
                companyName: selectedRowCopy.value?.companyName, 
                companyVatId: selectedRowCopy.value?.companyVatId, 
                companyLocation: selectedRowCopy.value?.companyLocation,
                comments: selectedRowCopy.value?.comments,
                isCompleted: selectedRowCopy.value?.isCompleted,
                userEmail: authService.getEmailAddress(), 
                ticketId: selectedRowCopy.value?.ticketId
            };        
            await insuranceClaims.put(postRequest)
            useNotifierWithErrFormatter().success({ msg: "Insurance Claim successfully edited." });
            emits("confirm");
            closeChild()   
        }
        
    }catch(error){
        useNotifierWithErrFormatter().error({error});
    }
    closeSpinner()
    working.value=false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    "model-value": !!selectedRow.value,
    title: "Edit Insurance Claim",
    hasClose: "",
    "onUpdate:modelValue": closeChild
  }, {
    contents: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(EditInsuranceClaim, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("select", {
              id: "market",
              class: "dropdown invalid-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedRowCopy.value.market) = $event)),
              disabled: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(markets), ([market,display]) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: market,
                  key: market
                }, _toDisplayString(display), 9, _hoisted_6))
              }), 128))
            ], 512), [
              [_vModelSelect, selectedRowCopy.value.market]
            ]),
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              class: "form-input invalid-input",
              type: "text",
              maxlength: "24",
              placeholder: "",
              id: "contractId",
              readonly: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedRowCopy.value.contractId) = $event))
            }, null, 512), [
              [_vModelText, selectedRowCopy.value.contractId]
            ]),
            _createElementVNode("span", _hoisted_8, [
              _createVNode(ToolTipLabel, {
                warning: "",
                tip: "After inserting this value claim becomes non editable",
                text: "Payment Date",
                forId: "datePicker"
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(DatePicker), {
                id: "datePicker",
                modelValue: selectedRowCopy.value.paymentDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedRowCopy.value.paymentDate) = $event)),
                type: "date",
                "enable-time-picker": false,
                format: FormatDatePicker,
                placeholder: "Select Payment Date...",
                "text-input-options": textInputOptions,
                "text-input": "",
                "max-date": new Date(),
                teleport: true,
                class: "invalid-input",
                disabled: selectedRowCopy.value.isCompleted == true,
                onInput: HandleFullAmountRequirementChange
              }, null, 8, ["modelValue", "max-date", "disabled"])
            ]),
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              class: "form-input invalid-input",
              type: "text",
              maxlength: "24",
              placeholder: "",
              id: "caseReference",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedRowCopy.value.caseReferenceId) = $event)),
              disabled: selectedRowCopy.value.isCompleted == true
            }, null, 8, _hoisted_11), [
              [_vModelText, selectedRowCopy.value.caseReferenceId]
            ]),
            _createElementVNode("span", _hoisted_12, [
              _createVNode(ToolTipLabel, {
                information: "",
                tip: "Full insurance payment amount excluding excess",
                text: "Full Amount",
                forId: "fullAmount"
              })
            ]),
            _createVNode(CurrencyInput, {
              modelValue: selectedRowCopy.value.fullAmount,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedRowCopy.value.fullAmount) = $event)),
              min: 0,
              currency: selectedRowCopy.value.market ? _unref(MarketCurrency)[selectedRowCopy.value.market] : undefined,
              id: "fullAmount",
              class: "invalid-input",
              required: fullAmmountRequiredFields.value,
              disabled: selectedRowCopy.value.isCompleted == true
            }, null, 8, ["modelValue", "currency", "required", "disabled"]),
            _createElementVNode("span", _hoisted_13, [
              _createVNode(ToolTipLabel, {
                information: "",
                tip: "Insurance company excess amount",
                text: "Excess Amount",
                forId: "excess"
              })
            ]),
            _createVNode(CurrencyInput, {
              modelValue: selectedRowCopy.value.excessAmount,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedRowCopy.value.excessAmount) = $event)),
              min: 0.01,
              currency: selectedRowCopy.value.market ? _unref(MarketCurrency)[selectedRowCopy.value.market] : undefined,
              id: "excess",
              class: "invalid-input",
              disabled: selectedRowCopy.value.isCompleted == true
            }, null, 8, ["modelValue", "currency", "disabled"]),
            _createElementVNode("span", _hoisted_14, [
              _createVNode(ToolTipLabel, {
                information: "",
                tip: "Name of the insurance company handling the case",
                text: "Company Name",
                forId: "companyName"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "form-input invalid-input",
              type: "text",
              maxlength: "30",
              id: "companyName",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedRowCopy.value.companyName) = $event)),
              disabled: selectedRowCopy.value.isCompleted == true
            }, null, 8, _hoisted_15), [
              [_vModelText, selectedRowCopy.value.companyName]
            ]),
            _createElementVNode("span", _hoisted_16, [
              _createVNode(ToolTipLabel, {
                information: "",
                tip: "VAT ID of the insurance company handling the case",
                text: "Company VAT ID",
                forId: "companyVat"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "form-input invalid-input",
              type: "text",
              maxlength: "30",
              id: "companyVat",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedRowCopy.value.companyVatId) = $event)),
              disabled: selectedRowCopy.value.isCompleted == true
            }, null, 8, _hoisted_17), [
              [_vModelText, selectedRowCopy.value.companyVatId]
            ]),
            _createElementVNode("span", _hoisted_18, [
              _createVNode(ToolTipLabel, {
                information: "",
                tip: "Location the insurance company handling the case",
                text: "Company Location",
                forId: "companyLocation"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "form-input invalid-input",
              type: "text",
              maxlength: "30",
              id: "companyLocation",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedRowCopy.value.companyLocation) = $event)),
              disabled: selectedRowCopy.value.isCompleted == true
            }, null, 8, _hoisted_19), [
              [_vModelText, selectedRowCopy.value.companyLocation]
            ]),
            _hoisted_20,
            _withDirectives(_createElementVNode("textarea", {
              class: "form-input textarea-input invalid-input",
              maxlength: "4096",
              spellcheck: "true",
              rows: "4",
              id: "comments",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedRowCopy.value.comments) = $event))
            }, null, 512), [
              [_vModelText, selectedRowCopy.value.comments]
            ])
          ]),
          _hoisted_21
        ], 40, _hoisted_3)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})